export default __webpack_public_path__ + "static/media/alumini (6).9e036adc.JPG";